import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';
import { useRegion } from '../app/region.js';

/**
 * Mijoz hududidagi do'konlar.
 *
 * Qoldiq matni shunga qarab quriladi: "Urganch do'konida 3 ta" yoki
 * "Toshkent do'konida bor · 2–3 kunda keltiramiz" (avtopart-ui skill).
 */
export function useHomeShopIds(): string[] {
  const { regionId } = useRegion();
  const shops = useQuery({ queryKey: ['shops'], queryFn: api.shops, staleTime: 600_000 });

  if (regionId === null) return [];
  return (shops.data ?? []).filter((shop) => shop.regionId === regionId).map((shop) => shop.id);
}
